export default {
  name: 'wisk-check',
  width: 35,
  height: 35,
  paths: [{ d: 'M34.257,9.158,15.89,29.741a2.977,2.977,0,0,1-4.385.094L.824,18.8a3.112,3.112,0,0,1-.141-4.056,2.4,2.4,0,0,1,3.631-.164L13.6,24.2,30.626,5.079a2.4,2.4,0,0,1,3.631,0A3.17,3.17,0,0,1,34.257,9.158Z' }]
}
